<i18n
  src="@/locales/components/views/service_provider/services/container_op/show_schedule/container_services.yml"
  lang="yaml"
></i18n>
<i18n src="@/locales/models/package_group.yml" lang="yaml"></i18n>

<template>
  <div>
    <div
      class="grid grid-cols-1 gap-y-0 gap-x-4 sm:grid-cols-6 justify-items-stretch"
    >
      <service-card
        v-for="service_template in service_templates"
        :key="service_template.id"
        :service_template="service_template"
        :container_service="getContainerService(service_template)"
      />
    </div>
  </div>
</template>

<script>
import ServiceCard from "@/components/views/service_provider/services/container_op/show_schedule/ServiceCard.vue";

export default {
  components: {
    ServiceCard,
    // EmptyCard
  },
  props: {
    container_scheduled_service: {
      type: Object,
    },
  },
  emits: ["update:packages-groups"],
  data() {
    return {
      pallet_charging: {},
    };
  },
  computed: {
    container_services: function () {
      return this.container_scheduled_service?.container_services ?? [];
    },
    service_templates: function () {
      return this.container_scheduled_service?.service_templates ?? [];
    },
    action_btn_class: function () {
      return "inline-flex justify-center py-2 px-4 border shadow-sm text-sm font-medium rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2";
    },
    agro_exporter_process_id: function () {
      return this.$router.currentRoute._value.params.agro_exporter_process_id;
    },
    card_width_class: function () {
      let cols = String(this.cols ?? 1);
      let width_class = `w-1/${cols}`;
      return `${width_class} lg:${width_class}`;
    },
    cols: function () {
      return 2;
    },
    rows: function () {
      return Math.ceil(this.service_templates.length / 2);
    },
  },
  methods: {
    cardRoundedClass: function (col, row) {
      let def_class =
        "relative group bg-white p-2 focus-within:ring-2 focus-within:ring-inset focus-within:ring-[#5c7a2e]";
      if (col == 1 && row == 1) def_class += " rounded-tl-lg";
      if (col == this.cols && row == 1) def_class += " sm:rounded-tr-lg";
      if (col == 1 && row == this.rows) def_class += " sm:rounded-bl-lg";
      if (col == this.cols && row == this.rows) def_class += " rounded-br-lg";
      return def_class;
    },
    changeCharging: function (package_group) {
      this.pallet_charging[package_group.id] =
        !this.pallet_charging[package_group.id];
    },
    getContainerService: function (service_template) {
      return this.container_services.find(
        (container_service) =>
          container_service.service_template_id == service_template.id
      );
    },
    getServiceTemplate: function (col, row) {
      let position = (row - 1) * this.cols + col - 1;
      return this.service_templates[position] ?? null;
    },
    goToNew: function () {
      this.$router.push({
        name: "ae_production_uniq_final_packing_list_new_package_group_path",
        params: {
          agro_exporter_process_id: this.agro_exporter_process_id,
          container_id: this.container_id,
        },
      });
    },
    goToUploadPackingList: function () {
      this.$router.push({
        name: "ae_production_uniq_final_packing_list_upload_packing_list_path",
        params: {
          agro_exporter_process_id: this.agro_exporter_process_id,
          container_id: this.container_id,
        },
      });
    },
    remove: function (package_group) {
      this.$emit(
        "update:packages-groups",
        this.container_services.filter((item) => item.id !== package_group.id)
      );
    },
    replacePackageGroup: function (package_group, new_package_group) {
      this.$emit(
        "update:packages-groups",
        this.container_services.map((item) =>
          item.id === package_group.id ? new_package_group : item
        )
      );
    },
  },
};
</script>

<style></style>
